import type { ComponentType } from "react";

import { CarIcon } from "@/components/icons/CarIcon";
import { CashIcon } from "@/components/icons/CashIcon";
import { FreeSpinsIcon } from "@/components/icons/FreeSpinsIcon";
import type { IconProps } from "@/components/icons/svgDefaults";
import { TicketsIcon } from "@/components/icons/TicketsIcon";
import { VipCoinsIcon } from "@/components/icons/VipCoinsIcon";

/** Maps a `WheelReward.id` from the content file to its icon. */
export const rewardIcons: Record<string, ComponentType<IconProps>> = {
  carro: CarIcon,
  tickets: TicketsIcon,
  "free-spins": FreeSpinsIcon,
  "coins-vip": VipCoinsIcon,
  dinheiro: CashIcon,
};
